<script setup lang="ts">
import { IdentificationIcon, OfficeBuildingIcon } from '@heroicons/vue/solid'
import { computed, onBeforeMount, reactive, ref, watch } from 'vue'
import { useLegalAccountDataState } from '../../../../utilities/account/useAccountDataLegal'
import AccountKycProcessTabs, { KycDocumentTabs } from '../../common/verification/AccountKycProcessTabs.vue'
import { i18n } from '../../../../localization'
import { isVisibleLegalProfileDocuments } from '../../../../validation'
import {
    LegalAccountNavigationStore,
    useLegalAccountNavigationState,
} from '../../../../utilities/account/useAccountNavigationLegal'
import { getPlatformSettings } from '../../../../utilities/usePlatformSettings'
import AccountDepotForm from '../../common/verification/AccountDepotForm.vue'

const navigationStore = useLegalAccountNavigationState() as LegalAccountNavigationStore
const store = useLegalAccountDataState()
const { legalProfile, kycDocuments: accountKycDocuments } = store
const platformSettings = getPlatformSettings()
const showDepot = computed(() => platformSettings.investment_desk_settings.show_depot_fields_on_profile_section)

onBeforeMount(() => {
    setKycDocs()
})

watch(accountKycDocuments, () => {
    setKycDocs()
})

function setKycDocs() {
    Object.keys(kycDocuments).forEach((key) => {
        if (kycDocuments.hasOwnProperty(key)) {
            kycDocuments[key].documents = []
        }
    })
    accountKycDocuments.forEach((kycD) => {
        if (kycDocuments.hasOwnProperty(kycD.verification_type)) {
            kycDocuments[kycD.verification_type].documents.push(kycD)
        }
    })
}

const kycDocuments = reactive({
    kyc_legal: {
        header: i18n.global.t('verification.legal_verification'),
        icon: IdentificationIcon,
        accepted: computed(() => legalProfile.kyc_legal),
        required: getPlatformSettings().require_kyc_id_for_investments,
        documents: [],
        show: computed(() => isVisibleLegalProfileDocuments('legal')),
        subheadline: i18n.global.t('verification.legal_verification_subheadline'),
    },
    depot: {
        header: i18n.global.t('verification.depot'),
        icon: OfficeBuildingIcon,
        show: showDepot,
        subheadline: i18n.global.t('verification.depot_verification_subheadline'),
    },
})

// if no tab is provided select kyc_legal
const currentTabKey = ref<keyof KycDocumentTabs>(navigationStore.tab || 'kyc_legal')
watch(currentTabKey, (val) => (navigationStore.tab = val))
</script>

<template>
    <AccountKycProcessTabs v-model:tab-key="currentTabKey" :kyc-document-tabs="kycDocuments" :account-store="store">
        <template #body>
            <div v-if="currentTabKey === 'depot'">
                <AccountDepotForm profile-type="legal" />
            </div>
        </template>
    </AccountKycProcessTabs>
</template>
